import { ReactComponent as MinusIcon } from "assets/icons/minus-icon.svg";
import { ReactComponent as PlusIcon } from "assets/icons/plus-icon.svg";
import useFormField from "hooks/form/useFormField";
import { useMemo } from "react";
import { validOption } from "utils/form/validations";

import * as S from "./InputNumber.style";

const InputNumber = ({
  options = [],
  validationRef,
  validationRules = [],
  initialValue = 1,
  onChange,
  ...props
}) => {
  const min = useMemo(() => options[0] || 1, [options]);
  const max = useMemo(() => [...options].reverse()[0] || 1, [options]);

  const { value, isValid, errorMessage, updateValue, validationId, validate } = useFormField({
    validationRef,
    validationRules: [...validationRules, validOption(options)],
    initialValue,
  });

  const up = () => {
    if (value < max) {
      updateValue(value + 1);
      onChange?.(value + 1);
    }
  };

  const down = () => {
    if (value > min) {
      updateValue(value - 1);
      onChange?.(value - 1);
    }
  };

  return (
    <div>
      <S.InputNumberContainer isValid={isValid}>
        <S.EmptyButton onClick={down} disabled={value <= min} type="button">
          <MinusIcon />
        </S.EmptyButton>
        <S.EmptyInput
          type="number"
          step={1}
          min={min}
          max={max}
          value={value}
          onBlur={validate}
          data-validationid={validationId}
          onChange={(v) => {
            const numberValue = Math.max(0, Math.min(+v.target.value, max));
            updateValue(numberValue);
            onChange?.(numberValue);
          }}
          isValid={isValid}
          {...props}
        />
        <S.EmptyButton onClick={up} disabled={value >= max} type="button">
          <PlusIcon />
        </S.EmptyButton>
      </S.InputNumberContainer>
      {!isValid && <S.ErrorMessage>{errorMessage}</S.ErrorMessage>}
    </div>
  );
};

export default InputNumber;
